import { STATUS_REPORT_OPTIONS } from '@/shared/config';

/**
 * Lists the report status values that exclude the finalised ones, for pickers that must not offer them. Filters 'Signed' and 'Completed' out of STATUS_REPORT_OPTIONS and maps the rest to their value field.
 *
 * @returns Report status values without 'Signed' and 'Completed'.
 */
const getListStatusReport = () => {
  /**
   * Holds the report status options excluding the finalized statuses. Derived by filtering STATUS_REPORT_OPTIONS to remove the 'Signed' and 'Completed' entries.
   *
   * @returns The filtered status option objects.
   */
  const filterStatusOptions = STATUS_REPORT_OPTIONS.filter(
    (opt) => opt.value !== 'Signed' && opt.value !== 'Completed',
  );
  return filterStatusOptions.map((opt) => opt.value);
};

/**
 * Lists every report status value available for filtering reports. Maps the STATUS_REPORT_OPTIONS entries down to their value field.
 *
 * @returns All report status values.
 */
const getListStatusAllReport = () => STATUS_REPORT_OPTIONS.map((opt) => opt.value);

export { getListStatusAllReport, getListStatusReport };
